import { render, staticRenderFns } from "./TaishokutodokeTextareaCard.vue?vue&type=template&id=a60ca1cc"
import script from "./TaishokutodokeTextareaCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaishokutodokeTextareaCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports